import { createContext, useContext, useState, ReactNode } from "react";

type PosCartGuardContextType = {
  posHasItems: boolean;
  setPosHasItems: (value: boolean) => void;
};

const PosCartGuardContext = createContext<PosCartGuardContextType | null>(null);

export const PosCartGuardProvider = ({ children }: { children: ReactNode }) => {
  const [posHasItems, setPosHasItems] = useState(false);

  return (
    <PosCartGuardContext.Provider value={{ posHasItems, setPosHasItems }}>
      {children}
    </PosCartGuardContext.Provider>
  );
};

export const usePosCartGuard = () => {
  const ctx = useContext(PosCartGuardContext);
  if (!ctx) {
    throw new Error("usePosCartGuard must be used within PosCartGuardProvider");
  }
  return ctx;
};
